import { render, staticRenderFns } from "./MaterialCategoryListExpand.vue?vue&type=template&id=f4587c50&"
import script from "./MaterialCategoryListExpand.js?vue&type=script&lang=js&"
export * from "./MaterialCategoryListExpand.js?vue&type=script&lang=js&"
import style0 from "./MaterialCategoryListExpand.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports